export default (string : string) => string.replace(/([a-z])([A-Z])/g, '$1-$2')
  .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/\s]/gi, '-')
  .toLowerCase();
